function drawResultsView(project) {
    resultsViewCanvas.clear();
    if( g_results == null ){
        return;
    }

    var beam = project.beam;
    
    if( beam.nodes.length <= 1 ){ return; }

    var resultLabel = $("#result-group-selector").val();
    if( resultLabel == null ){ resultLabel = "load_case_results"; }

    var resultCases = g_results[resultLabel];
    if(!resultCases) { return; }

    var selectedResultCaseIndex = document.getElementById("numerical-results-selector").selectedIndex
    const resultCase = resultCases[selectedResultCaseIndex];

    //****************************
    // Make our displacement array
    //****************************
    var totalLength = beam.TotalLength();

    var xScale = canvasRect[0]/(1.2*totalLength);

    var xStart = 0.05*totalLength*xScale;

    var yOffset = canvasRect[1] * 0.30;

    let maxAbsoluteDy = 1e-6;
    for(var i in resultCase["displacements"]) {
        if(Math.abs(resultCase["displacements"][i]["dy"]) > maxAbsoluteDy) {
            maxAbsoluteDy = Math.abs(resultCase["displacements"][i]["dy"]);
        }
    }

    var xs = [];
    var ys = [];
    for(var i in resultCase["displacements"]) {
        xs.push(xStart + xScale * resultCase["displacements"][i]["x"]);
        ys.push(yOffset - resultCase["displacements"][i]["dy"] / maxAbsoluteDy * 50);
    }

    // gradient values; displacements, moments or shears
    const gradientValues = resultCase['displacements'].map( r => r['dy'] )
    
    drawBeamSpanResultsView(xs, ys, gradientValues, resultsViewCanvas)

    const legendWidth = 15
    const legendHeight = canvasRect[1] * 0.9
    const legendX = canvasRect[0] - 20
    const legendY = (canvasRect[1] - legendHeight) * 0.5

    // get max and min values
    let gradientMin = 1e9
    let gradientMax = -1e9
    gradientValues.forEach( val => {
        gradientMin = Math.min(gradientMin, val)
        gradientMax = Math.max(gradientMax, val)
    })

    //************************
    // Legend
    //************************
    if(Math.abs(gradientMin) < Math.abs(gradientMax)) {
        const v = gradientMin
        gradientMin = gradientMax
        gradientMax = v
    }
    const gradientMinLabel = showSmallLengthWithUnits(gradientMin)
    const gradientMaxLabel = showSmallLengthWithUnits(gradientMax)

    drawResultViewLegend(legendX, legendY, legendWidth, legendHeight, gradientMinLabel, gradientMaxLabel, resultsViewCanvas)

    //*******************
    // Reactions
    //*******************
    var nReactions = resultCase["node_reactions"].length;
    var equation = numericalCaseSet["equations"][selectedResultCaseIndex];
    var loadCaseLabels = Object.keys(equation);
    
    for( var s = 0; s < nReactions; s++ ) {
        var x = resultCase["node_reactions"][s]["x"];
        if(project.beam.isNodeAtThisLocation(x) === false) {
            continue;
        }

        // we also check to see if there is a point load directly over a support. the finite element method
        // will not show a reaction at this location so we manually add it in.
        // if there is a point load here and the support is fixed or pinned we apply our combination equation:
        //    sum(equation[loadCase] * pointLoadAtReaction[loadCase])
        var force = resultCase["node_reactions"][s]["fy"];
        var pointLoadAtReaction = project.beam.getPointLoadAtLocation(x);
        if(pointLoadAtReaction && project.beam.isSupportPinnedOrFixed(x)) {
            var additionalLoad = 0;
            loadCaseLabels.forEach( loadCaseLabel => {
                const factor = Number(equation[loadCaseLabel]);
                const load = Number(pointLoadAtReaction[loadCaseLabel]);
                if(!isNaN(factor) && !isNaN(load)) {
                    additionalLoad += factor * load;
                }
            });
            force += additionalLoad;
        }

        if(force !== 0) {
            force = (gUnits === ENGLISH_UNITS) ? force.toFixed(0) : Number(force * 4.44822).toFixed(0);
            var forceLabel = showBigPointLoad(force) + " " + bigPointLoadUnit();
            var direction = force > 0 ? "up" : "down";
            drawForceReaction(direction, xStart + xScale * x, yOffset , forceLabel, resultsViewCanvas);
        }

        var moment = resultCase["node_reactions"][s]["mz"];
        if(moment !== 0) {
            moment = (gUnits === ENGLISH_UNITS) ? moment.toFixed(0) : Number(moment * 0.11298482933333).toFixed(0);
            var momentLabel = showBigMoment(moment) + bigMomentUnit();
            drawMomentReaction(xStart + xScale * x, yOffset, 0, momentLabel, resultsViewCanvas);
        }
    }


    //*******************
    // Extremes
    //*******************
    const extremes = getExtremes(resultCase)
    const maxDy = extremes['maxDy']
    const maxFy = extremes['maxFy']
    const maxMz = extremes['maxMz']

    drawExtremeDimension(xStart, xStart + maxDy[0] * xScale, yOffset + 100,
        "Max Dy = " + showSmallLengthWithUnits(maxDy[1]) + " @ " + showLengthWithUnits(maxDy[0]), resultsViewCanvas);
    drawExtremeDimension(xStart, xStart + maxFy[0] * xScale, yOffset + 140,
        "Max Shear = " + showBigPointLoad(maxFy[1]) + " " + bigPointLoadUnit() + " @ " + showLengthWithUnits(maxFy[0]), resultsViewCanvas);
    drawExtremeDimension(xStart, xStart + maxMz[0] * xScale, yOffset + 180,
        "Max Moment = " + showBigMoment(maxMz[1]) + " " + bigMomentUnit() + " @ " + showLengthWithUnits(maxMz[0]), resultsViewCanvas);

}

function updateResultsViews(selectedIndex) {
    updateNumericalResultsTable(selectedIndex);
    drawResultsView(activeProject);
}

/***
* Called from beam controller after a calculation
***/
function showNumericalResults(results) {
    if( results == null ){
        return;
    }

    g_results = results;

    $('#numerical-results-div').removeClass('hidden');
    $('#results-view-div').removeClass('hidden');

    onResultGroupChange();
}

function onResultGroupChange() {
    var design = activeProject.design;
    if( g_results == null ){
        alert( "g_results is null");
        return;
    }
    var resultLabel = $("#result-group-selector").val();
    if( resultLabel == null ){
        resultLabel = "load_case_results";
    }
    var resultCases = g_results[resultLabel];
    if( !resultCases ) return;
    if( resultLabel == "load_case_results"){
        numericalCaseSet = design.loadCases;
    }else if( resultLabel == "combination_results"){
        numericalCaseSet = design.loadCombination;
    }else if( resultLabel == "service_case_results"){
        numericalCaseSet = design.serviceCases;
    }
    //update the numerical results selector...
    var str = "<select id='numerical-results-selector' onchange='updateResultsViews(this.selectedIndex);return false;'>";
    for( var i = 0; i < resultCases.length; i++ ) {
        var resultCase = resultCases[i];
        var ugly_eqn_name = resultCase["equation_name"];
        var nice_eq_index = Number(numericalCaseSet["uglyToPrettyMap"][ugly_eqn_name]);
        var nice_label = numericalCaseSet["prettyEquations"][nice_eq_index-1]["EQ"];
        str += "<option value="+i+">"+nice_label+"</option>";
    }
    str += "</select>";
    $("#numerical-results-selector-holder").html(str);

    updateResultsViews(0);
}

function getExtremes(resultCase) {
    var maxDy = [0, 0];    //[index, value]
    var maxFy = [0, 0];
    var maxMz = [0, 0];

    for(var i = 0; i < resultCase["nodal_forces"].length; i++) {
        var x = Number(resultCase["nodal_forces"][i]['x']);
        var fy = Number(resultCase["nodal_forces"][i]['fy']);
        if(Math.abs(fy) > Math.abs(maxFy[1])) {
            maxFy = [x, fy];
        }
    }

    for( var i = 0; i < resultCase["nodal_forces"].length; i++ ) {
        var x = Number(resultCase["nodal_forces"][i]['x']);
        var mz = Number(resultCase["nodal_forces"][i]['mz']);
        if(Math.abs(mz) > Math.abs(maxMz[1])) {
            maxMz = [x, mz];
        }
    }

    for( var i = 0; i < resultCase["displacements"].length; i++ ) {
        var x = resultCase["displacements"][i]["x"];
        var dy = Number(resultCase["displacements"][i]["dy"]);
        if( Math.abs(dy) > Math.abs(maxDy[1])) {
            maxDy = [x, dy];
        }
    }

    return {'maxDy': maxDy, 'maxFy': maxFy, 'maxMz': maxMz}
}

function updateNumericalResultsTable(index) {

    // update the title first
    var sel = document.getElementById("result-group-selector");
    var group = sel.options[sel.selectedIndex].text;
    sel = document.getElementById("numerical-results-selector");
    var equation = sel.options[sel.selectedIndex].text;
    document.getElementById("numerical-results-equation-title").innerHTML = group + " " + equation;

    var resultLabel = $("#result-group-selector").val();
    if( resultLabel == null ){
        resultLabel = "load_case_results";
    }
    var resultCase = g_results[resultLabel][index];
    var max_dy = [0, 0];    //[index, value]
    var max_rz = [0, 0];
    var max_fy = [0, 0];
    var max_mz = [0, 0];

    var shears = [];
    var moments = [];

    var str = "<h4>Details</h4>";
    str += "<table class='table'>";
    str += "<tr class='ws-ui-table-header-row ws-ui-left'>";
    str += "<th>Location (" + smallLengthUnit() + ")</th>";
    str += "<th>Dy (" + smallLengthUnit() + ")</th>";
    if( debug )
        str += "<th>Rz (radians)</th>";
    str += "<th>Shear (" + smallPointLoadUnit() + ")</th>";
    str += "<th>Moment " + smallMomentUnit() + "</th>";

    for(var i = 0; i < resultCase["nodal_forces"].length; i++) {
        var x = Number(resultCase["nodal_forces"][i]['x']);
        var fy = Number(resultCase["nodal_forces"][i]['fy']);
        if(Math.abs(fy) > Math.abs(max_fy[1])) {
            max_fy = [x, fy];
        }
        shears.push(fy);
    }

    for( var i = 0; i < resultCase["nodal_forces"].length; i++ ) {
        var x = Number(resultCase["nodal_forces"][i]['x']);
        var mz = Number(resultCase["nodal_forces"][i]['mz']);
        if(Math.abs(mz) > Math.abs(max_mz[1])) {
            max_mz = [x, mz];
        }
        moments.push(mz.toFixed(2));
    }

    for( var i = 0; i < resultCase["displacements"].length; i++ ) {
        var x = resultCase["displacements"][i]["x"];
        var dy = Number(resultCase["displacements"][i]["dy"]);
        if( Math.abs(dy) > Math.abs(max_dy[1])) {
            max_dy = [x, dy];
        }

        str += "<tr class='ws-ui-table-row'>";
        str += "<td>" + showSmallLength(x).toFixed(2) + "</td>";
        str += "<td>" + showSmallLength(dy).toFixed(2)  + "</td>";
        var vy = shears[i];
        var mz = moments[i];

        str += "<td>" + showSmallPointLoad(vy) + "</td>";
        str += "<td>" + showSmallMoment(mz) + "</td>";
        str += "</tr>";
    }
    str += "</table>";

    $("#beam-numerical-results-table").html(str);

    var max_str = "<strong>Extremes</strong>";
    max_str += "<table class='table'>";
    max_str += "<tr class='ws-ui-table-header-row '>";
    max_str += "<th class='ws-ui-left ws-ui-table-150'>Type</th>";
    max_str += "<th>Location</th>";
    max_str += "<th>Value</th>";

    var i = max_dy[0];
    max_str += "<tr class='ws-ui-table-row'>";
    max_str += "<th class='ws-ui-left ws-ui-table-150'>Max dy</th>";
    max_str += "<td>" + showLengthWithUnits(max_dy[0]) + "</td>";
    max_str += "<td>" + showSmallLengthWithUnits(max_dy[1]) + "</td>";
    max_str += "</tr>";

    i = max_fy[0];
    max_str += "<tr class='ws-ui-table-row'>";
    max_str += "<th class='ws-ui-left ws-ui-table-150'>Max Shear</th>";
    max_str += "<td>" + showLengthWithUnits(max_fy[0]) + "</td>";
    max_str += "<td>" + showBigPointLoad(max_fy[1]) + " " + bigPointLoadUnit() + "</td>";
    max_str += "</tr>";

    //showBigMoment(controlling_Mu) + bigMomentUnit()
    i = max_mz[0];
    max_str += "<tr class='ws-ui-table-row'>";
    max_str += "<th class='ws-ui-left ws-ui-table-150'>Max Moment</th>";
    max_str += "<td>" + showLengthWithUnits(max_mz[0]) + "</td>";
    max_str += "<td>" + showBigMoment(max_mz[1]) + " " + bigMomentUnit() + "</td>";
    max_str += "</tr>";

    max_str += "</table><br>";

    $("#extreme-results-table").html(max_str);

    //$("#beam-numerical-results-table").html(max_str + str);
}

var previousPoint = null;
function showTooltip(x, y, contents) {
    $('<div id="tooltip">' + contents + '</div>').css( {
        position: 'absolute',
        display: 'none',
        top: y + 5,
        left: x + 5,
        border: '1px solid #fdd',
        padding: '2px',
        'background-color': '#fee',
        opacity: 0.80
    }).appendTo("body").fadeIn(200);
}

function toolTipHover(event, pos, item) {
    if (item) {
        if (previousPoint != item.datapoint) {
            previousPoint = item.datapoint;

            $("#tooltip").remove();
            var x = item.datapoint[0].toFixed(2),
                y = item.datapoint[1].toFixed(3);

            showTooltip(item.pageX, item.pageY,
                        item.series.label + " @ " + x + " = " + y);
        }
    } else {
        $("#tooltip").remove();
        previousPoint = null;
    }
}

function onPlotResultGroupChange() {
    var resultLabel = $("#plot-result-group-selector").val();
    updateResultCharts(resultLabel);
}

function showResultCharts(results) {
    $('#plots-div').removeClass('hidden');
    g_results = results;
    var str = '<h3 class="panel-title">Plots &nbsp;&nbsp;';
    str += "<select id='plot-result-group-selector' onchange='onPlotResultGroupChange();return false;'>";
    str += "<option value='load_case_results'>Load Cases</option>";
    str += "<option value='combination_results' selected>Load Combinations</option>";
    str += "<option value='service_case_results'>Service Cases</option>";
    str += "</select>";

    $("#plots-heading").html(str);

    str = '<div class="calc-content">';
    str += '<div class="section-header">Dy ';
    str += gUnits === ENGLISH_UNITS ? '(inches)' : '(mm)' + '</div>';
    str += '<div id="beam-disp-graph" style="height:250px;"></div>';
    if( debug ){
        str += '<div class="section-header">Theta (radians)</div>';
        str += '<div id="beam-theta-graph" style="height:250px;"></div>';
    }
    str += '<div class="section-header">Shear ';
    str += gUnits === ENGLISH_UNITS ? '(lbs)' : '(N)' + '</div>';
    str += '<div id="beam-shear-graph" style="height:250px;"></div>';
    str += '<div class="section-header">Moment ';
    str += gUnits === ENGLISH_UNITS ? '(lb-in)' : '(N-m)' + '</div>';
    str += '<div id="beam-moment-graph" style="height:250px;"></div>';
    str += '<div class="section-header">Legend</div>';
    str += '<div id="beam-graph-legend" class="table"></div>';
    str += '</div>';

    $("#plot-panel-area").html( str );
    onPlotResultGroupChange();
    updateResultCharts("combination_results");
}

function updateResultCharts(resultGroupLabel) {
    //flot in ie is currently (version 8) super slow
    var design = activeProject.design;
    var results = g_results;
    var resultCases = results[resultGroupLabel];
    var caseSet = design.loadCases;
    if( resultGroupLabel == "load_case_results"){
        caseSet = design.loadCases;
    }else if( resultGroupLabel == "combination_results"){
        caseSet = design.loadCombination;
    }else if( resultGroupLabel == "service_case_results"){
        caseSet = design.serviceCases;
    }

    function ShowDispChart( item, graph_element, show_legend ){
        var options = {
            legend: { show: show_legend, noColumns: 2, container:$("#beam-graph-legend") },
            lines: { show: true },
            points: { show: true },
            grid: { hoverable: true }
        };
        var d = [];
        for(var i = 0; i < resultCases.length; i++) {
            var resultCase = resultCases[i];
            var res = resultCase["displacements"];
            var d1 = [];
            for(var j = 0; j < res.length; j++) {
                d1.push(
                    [showDistanceLength(Number(res[j]["x"])),
                    showSmallLength(Number(res[j][item])).toFixed(4)]);
            }
            var ugly_eqn_name = resultCase["equation_name"];
            var nice_eq_index = Number(caseSet["uglyToPrettyMap"][ugly_eqn_name]);
            var nice_label = caseSet["prettyEquations"][nice_eq_index-1]["EQ"];
            d.push( {label: nice_label, data: d1 } );
        }
        $(graph_element).bind("plothover", toolTipHover);
        $.plot($(graph_element), d, options);
    }
    ShowDispChart( "dy", "#beam-disp-graph", true );
    if( debug )
        ShowDispChart( "rz", "#beam-theta-graph", false );

    function ShowForceChart( item, graph_element ){
        var options = {
            lines: { show: true },
            legend: { show: false },
            points: { show: true },
            grid: { hoverable: true }
        };
        var d = [];
        for( var i = 0; i < resultCases.length; i++ ) {
            var resultCase = resultCases[i];
            var res = resultCase["nodal_forces"];
            var d1 = [];
            for( var j = 0; j < res.length; j++ ) {
                d1.push([Number(res[j]["x"]), Number(res[j][item]).toFixed(4)]);
            }
            var ugly_eqn_name = resultCase["equation_name"];
                var nice_eq_index = Number(caseSet["uglyToPrettyMap"][ugly_eqn_name]);
                var nice_label = caseSet["prettyEquations"][nice_eq_index-1]["EQ"];
                d.push( {label: nice_label, data: d1 } );
        }
        $(graph_element).bind("plothover", toolTipHover);
        $.plot($(graph_element), d, options);
    }
    ShowForceChart( "fy", "#beam-shear-graph" );
    ShowForceChart( "mz", "#beam-moment-graph" );
}

function showDesignCheckSummary(results) {
    $('#design-summary-div').removeClass('hidden');
    //basic design or parametric shapes...
    //check unity...
    //bending
    //currently we don't do much for Design = None...ask Tom to add in simple ultimate strength checks for
    //bending and shear when Design = None
    var bending_unity = g_results["bending_checks"]["controlling_unity"];
    var shear_unity = g_results["shear_checks"]["controlling_unity"];
    var deflection_unity = g_results["deflection_checks"]["controlling_unity"];
    var str = '';
    if( bending_unity < 1.0 && shear_unity < 1.0 && deflection_unity < 1.0 ){
        $('#design-summary-panel').removeClass('panel-danger');
        $('#design-summary-panel').addClass('panel-success');
        $('#top-design-summary-panel').removeClass('panel-danger');
        $('#top-design-summary-panel').addClass('panel-success');
        $('.current-design-status').html('<i class="glyphicon glyphicon-ok text-success"></i> Design OK');
        if(activeProject.design.designType === 'None') {
            $('.current-design-status').html('<i class="glyphicon glyphicon-ok text-success"></i> Beam OK');
        }
        $('#drawing-panel').removeClass('panel-danger');
        $('#drawing-panel').addClass('panel-success');
    }else{
        $('#design-summary-panel').addClass('panel-danger');
        $('#design-summary-panel').removeClass('panel-success');
        $('#top-design-summary-panel').addClass('panel-danger');
        $('#top-design-summary-panel').removeClass('panel-success');
        $('.current-design-status').html('<i class="glyphicon glyphicon-remove text-danger"></i> Failed');
        $('#drawing-panel').addClass('panel-danger');
        $('#drawing-panel').removeClass('panel-success');
    }
    $('#design-summary-load-combination').html(activeProject.designTypeStr + ' - ');
    $('#design-summary-shape').html(activeProject.shapeName + ' ');
    var materialName = activeProject.isCustom ? "" : activeProject.materialName;
    if(activeProject.isEngineeredLumber) {
        materialName = "";
    }
    $('#design-summary-material').html(materialName);

    showBendingCheckSummary();
    showShearCheckSummary();
    showDeflectionCheckSummary();
    showDesignInfoSummary();
    showReactionsSummary(results);
}

function setDesignPanelSuccessOrFail(success, panel_dom_id) {
    if (success) {
        $(panel_dom_id).removeClass('panel-danger');
        $(panel_dom_id).addClass('panel-success');
    } else {
        $(panel_dom_id).addClass('panel-danger');
        $(panel_dom_id).removeClass('panel-success');
    }
}

function showDeflectionCheckSummary() {
    //get service case results...
    var design = activeProject.design;
    var checks = g_results["deflection_checks"];
    var controlling_unity = checks["controlling_unity"];
    var controlling_case = checks["controlling_case"];
    var max_dy = checks["max_dy"];
    var success = controlling_unity < 1.0;
    var designStatusStr = success ? '<i class="glyphicon glyphicon-ok text-success"></i>' : '<i class="glyphicon glyphicon-remove text-danger"></i>';
    setDesignPanelSuccessOrFail(success, '#deflection-design-panel');

    var str = '<div class="panel-heading">';
    str += '<h3 class="panel-title"><span class="">';
    str += designStatusStr + ' Deflection</span><span class="pull-right">' + controlling_unity.toFixed(2) + '</span></h3></div>';

    str += "<table class='table'>";

    str += "<tr>";
    str += "<td>Based On</td>";
    str += "<td><span style='float:right;'>Service Cases</span></td></tr>";

    str += "<tr>";
    str += "<td>Controlling Service Case</td>";
    str += "<td><span style='float:right;'>"+ controlling_case + "</span></td></tr>";

    str += "<tr>";
    str += "<td>Max Dy</td>";
    str += "<td><span style='float:right;'>";
    str += showSmallLengthWithUnits(max_dy);
    str += " = L/"+ Math.ceil(activeProject.beam.TotalLength()/Math.abs(max_dy)/10)*10;
    str += "</span></td></tr>";

    str += "<tr>";
    str += "<td>Live Load Limit</td>";
    str += "<td><span style='float:right;'>L/"+design.liveLoadLimit+"</span></td></tr>";

    str += "<tr>";
    str += "<td>Dead + Live Limit</td>";
    str += "<td><span style='float:right;'>L/"+design.deadPlusLiveLoadLimit+"</span></td></tr>";

    str += "<tr>";
    str += "<td>Snow or Wind Limit</td>";
    str += "<td><span style='float:right;'>L/"+design.snowOrWindLoadLimit+"</span></td></tr>";

    str += "<tr>";
    str += "<td>Total Load Limit</td>";
    str += "<td><span style='float:right;'>L/"+design.totalLoadLimit+"</span></td></tr>";

    if(activeProject.isEngineeredLumber) {
        str += "<tr>";
        str += "<td>Shear Deformation Included</td>";
        var Asx = "Asx = A(5 + 5&nu;)/(6 + 5&nu;)";
        str += "<td><span style='float:right;'>" + Asx + "</span></td></tr>";
    }
    str += "</table>";
    $("#deflection-design-panel").html(str);
}

function showDesignInfoSummary() {
    var design = activeProject.design;
    var str = '<div class="panel-heading">';
    str += `<h3 class="panel-title">Design Info<span class="pull-right">${activeProject.designTypeStr}</span></h3></div>`

    str += "<table class='table'>";
    str += "<tr>";
    str += "<td>Shape Type</td>";
    str += "<td><span style='float:right;'>"+ activeProject.shapeName +"</td></tr>";

    if(activeProject.isEngineeredLumber) {
        str += "<tr>";
        str += "<td>Number of Plys</td>";
        str += "<td><span style='float:right;'>"+ activeProject.numberOfPlys + "</td></tr>";
    }

    str += "<tr>";
    str += "<td>Weight</td>";
    str += "<td><span style='float:right;'>"+ activeProject.shapeWeightString +"</td></tr>";

    str += "<tr>";
    str += "<td>Self Weight</td>";
    str += "<td><span style='float:right;'>"+ ((design.includeSelfWeight) ? "Included" : "Not Included") + "</td></tr>";

    str += "<tr>";
    str += "<td>Ix</td>";
    str += "<td><span style='float:right;'>"+ activeProject.shapeIxString + "</td></tr>";

    if(!activeProject.isEngineeredLumber) {
        str += "<tr>";
        str += "<td>Iy</td>";
        str += "<td><span style='float:right;'>"+ activeProject.shapeIyString + "</td></tr>";

        str += "<tr>";
        str += "<td>Cross Section Rotation</td>";
        str += "<td><span style='float:right;'>"+ activeProject.beam.crossSectionRotation + "&deg;</td></tr>";
    }

    str += "<tr>";
    str += "<td>Bracing</td>";

    //continuous, equal, custom, unbraced
    if(activeProject.isEngineeredLumber) {
        str += "<td><span style='float:right;'>Continuous Assumed</span></td></tr>";
    } else if( design.bracingType === 'continuous' ) {
        str += "<td><span style='float:right;'>Continuous</span></td></tr>";
    }else if( design.bracingType === "equal" ){
        str += "<td><span style='float:right;'>Braced @ " + showSmallLengthWithUnits(activeProject.design.getBraceSpacing()) +"</span></td></tr>";
    }else if( design.bracingType === "unbraced" ){
        str += "<td><span style='float:right;'>None</span></td></tr>";
    }else{
        str += "<td><span style='float:right;'>Custom</span></td></tr>";
        str += "<tr>";
        str += "<td>At Inflection Points</td>";
        if( design.bracesAtInflectionPoints ){
            str += "<td><span style='float:right;'>Yes</span></td></tr>";
        }else{
            str += "<td><span style='float:right;'>No</span></td></tr>";
        }
    }
    str += "</table>";
    $("#design-info-summary-panel").html(str);
}


function showReactionsSummary(results) {
    $('#beam-reactions-div').removeClass('hidden');

    var loadCaseResults = results["load_case_results"];
    var nReactions = loadCaseResults[0]["node_reactions"].length;

    var units = (gUnits === ENGLISH_UNITS) ? "(lbs)" : "(N)";
    var str = "<h4>Fy Reactions " + units + "<span style='float:right;'></span></h4>";
    str += "<table class='table'>";
    str += "<tr>";
    str += "<th>Support</th>";
    str += "<th >D</th>";
    str += "<th >L</th>";
    str += "<th >Lr</th>";
    str += "<th >S</th>";
    str += "<th >W</th>";
    str += "<th>E</th>";
    str += "<th>H</th>";
    str += "<th>R</th><tr>";

    var supportIndex = 1;
    for( var s = 0; s < nReactions; s++ ) {
        var x = loadCaseResults[0]["node_reactions"][s]["x"];
        if(activeProject.beam.isNodeAtThisLocation(x) === false) {
            continue;
        }
        str += "<tr><td>" + (supportIndex++).toString() + "</td>";
        for( var lc = 0; lc < loadCaseResults.length; lc++) {
            var reaction = loadCaseResults[lc]["node_reactions"][s]["fy"];
            var res = (gUnits === ENGLISH_UNITS) ? reaction.toFixed(0) : Number(reaction * 4.44822).toFixed(0);
            str += "<td>" + res + "</td>";
        }
        str += "</tr>";
    }
    str += "</table>";

    units = (gUnits === ENGLISH_UNITS) ? "(lb-in)" : "(N-m)";
    str += "<h4>Mz Reactions " + units + "<span style='float:right;'></span></h4>";
    str += "<table class='table'>";
    str += "<tr>";
    str += "<th>Support</th>";
    str += "<th>D</th>";
    str += "<th>L</th>";
    str += "<th>Lr</th>";
    str += "<th>S</th>";
    str += "<th>W</th>";
    str += "<th>E</th>";
    str += "<th>H</th>";
    str += "<th>R</th><tr>";

    supportIndex = 1;
    for( var s = 0; s < nReactions; s++ ) {
        var x = loadCaseResults[0]["node_reactions"][s]["x"];
        if(activeProject.beam.isNodeAtThisLocation(x) === false) {
            continue;
        }
        str += "<tr><td>" + (supportIndex++).toString() + "</td>";
        for( var lc = 0; lc < loadCaseResults.length; lc++) {
            var reaction = loadCaseResults[lc]["node_reactions"][s]["mz"];
            var res = (gUnits === ENGLISH_UNITS) ? reaction.toFixed(0) : Number(reaction * 0.11298482933333).toFixed(0);
            str += "<td>"+ res +"</td>";
        }
        str += "</tr>";
    }
    str += "</table>";

    $("#beam-reactions-table").html(str);
}